import React from "react";
import TextField from "@material-ui/core/TextField";

export default function LogInForm() {
  return (
    <>
      <TextField
        autoFocus
        margin="dense"
        id="name"
        label="Username"
        type="text"
        fullWidth
      />

      <TextField
        margin="dense"
        id="name"
        label="Email Address"
        type="email"
        fullWidth
      />

      <TextField
        margin="dense"
        id="name"
        label="Password"
        type="text"
        fullWidth
      />

      <TextField
        margin="dense"
        id="name"
        label="Re-Password"
        type="text"
        fullWidth
      />
    </>
  );
}
